import React from 'react';

const MainFieldCard = ({ fieldCards }) => {

  return (
    <div className={fieldCards.wrapClass}>
      <div className={fieldCards.titleClass}>
        {fieldCards.title}
      </div>
      <div className={fieldCards.cardLineClass}></div>
      <div className={fieldCards.cardImgClass}>
        <img src={fieldCards.imgPath} alt='�ʵ��̹���'/>
      </div>
    </div>
  );
}

export default MainFieldCard;
